module.exports = __webpack_public_path__ + "img/book_01.d97787b6.png";